const css = `.Z0nUBq__wideButton{width:100%;justify-content:center}.Z0nUBq__textN10{color:#3a4b59}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"textN10":"Z0nUBq__textN10","wideButton":"Z0nUBq__wideButton"};
